"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.MainDeliveryMethodContent = exports.LoadingOverlay = exports.FlatDeliveryWrapper = exports.DeliverySummaryInfo = exports.DeliverySummaryHeader = exports.DeliverySummaryCourierInfo = exports.DeliverySummaryContent = exports.DeliveryHeader = exports.ContinueButton = exports.ChangeText = exports.Change = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
// corresponding with the grid style
const OLD_MD_BREAKPOINT = 768;
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(4, 6),
        width: 'auto',
        maxWidth: 980,
        margin: theme.spacing(0, 'auto', 4),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.largeComponentRadius,
        [theme.breakpoints.down(OLD_MD_BREAKPOINT)]: {
            borderRadius: 0
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(4, 3)
        }
    };
});
const LoadingOverlay = exports.LoadingOverlay = (0, _mui.styled)(_mui.Backdrop)({
    zIndex: 1
});
const DeliveryHeader = exports.DeliveryHeader = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: theme.spacing(3)
    };
});
const Change = exports.Change = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        marginBottom: theme.spacing(2)
    };
});
const ChangeText = exports.ChangeText = (0, _mui.styled)(_mui.Typography)({
    fontWeight: 'bold',
    textDecoration: 'underline'
});
const FlatDeliveryWrapper = exports.FlatDeliveryWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexFlow: 'column',
        gap: theme.spacing(8)
    };
});
const MainDeliveryMethodContent = exports.MainDeliveryMethodContent = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        fontWeight: 'bold',
        gap: theme.spacing(3),
        justifyContent: 'space-between',
        justifySelf: 'stretch'
    };
});
const ContinueButton = exports.ContinueButton = (0, _mui.styled)(_components.Button)({
    display: 'flex',
    margin: 'auto',
    maxWidth: 330
});
const DeliverySummaryHeader = exports.DeliverySummaryHeader = (0, _mui.styled)('div')({
    display: 'flex',
    justifyContent: 'space-between'
});
const DeliverySummaryContent = exports.DeliverySummaryContent = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'grid',
        gap: theme.spacing(4),
        [theme.breakpoints.up('sm')]: {
            gridTemplateColumns: '1fr 1fr'
        }
    };
});
const DeliverySummaryInfo = exports.DeliverySummaryInfo = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    };
});
const DeliverySummaryCourierInfo = exports.DeliverySummaryCourierInfo = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        gap: theme.spacing(2)
    };
});
